import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../store/rootReducer";

export const selectDocumentsState = (state: RootState) => state.documents;

export const selectDocumentById = createSelector(
  [selectDocumentsState, (_state: RootState, id: string) => id],
  (state, id) => state.byId[id]
);

export const selectDocuments = createSelector([selectDocumentsState], (state) =>
  state.allIds.map((id) => state.byId[id])
);

export const selectDocumentsLoading = createSelector(
  [selectDocumentsState],
  (state) => state.loading
);

export const selectDocumentsError = createSelector(
  [selectDocumentsState],
  (state) => state.error
);

export const selectDocumentsFilters = createSelector(
  [selectDocumentsState],
  (state) => state.filters
);
